import { render, staticRenderFns } from "./View.vue?vue&type=template&id=c69ecf76&scoped=true"
import script from "./View.vue?vue&type=script&lang=ts"
export * from "./View.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69ecf76",
  null
  
)

export default component.exports